import React from 'react'
import {Popup} from 'semantic-ui-react'
import {PoeChip, POE_POPUP_TEXT} from '../purchase-orders/poe-chip'

// poeInfo is keyed by upcased customer PO number — see Api::Cads2Controller#poe_info.
// No entry means the order is not POE, or has no ERP purchase_order row.
const isPoeOrder = (poeInfo, ponumber) => {
  if (poeInfo == null || ponumber == null) { return false }
  return !!poeInfo[ponumber.trim().toUpperCase()]
}

const poeChipPopup = (poeInfo, ponumber) => {
  if (!isPoeOrder(poeInfo, ponumber)) { return null }

  return (
    <Popup
      size='mini'
      header='POE order'
      content={POE_POPUP_TEXT}
      position='bottom left'
      trigger={<PoeChip/>}
    />
  )
}

export {poeChipPopup, isPoeOrder}
